import PeliasRequest from './pelias/request';

const Pelias = function (locationType, language, country, baseUrl) {
  this.geocode = function (term, callback) {
    const request = new PeliasRequest({
      locationType: locationType,
      baseUrl: baseUrl,
    });
    request.autoComplete(term, callback);
  };

  this.reverseGeocode = function (latitude, longitude, callback) {
    const request = new PeliasRequest({
      locationType: 'locality,localadmin,borough,macrohood,postalcode,county',
      baseUrl: baseUrl,
    });
    request.reverseGeocode(latitude, longitude, callback);
  };

  this.resultSelected = function (autoCompletedResult, callback) {
    callback(autoCompletedResult);
  };
};

export default Pelias;
